/**
 * Resource danh mục loại hoạt động tài chính
 * ndhieu3 20.04.2023
 */
export default {
  ActivityCategory: {
    SearchDescription: 'Tìm kiếm theo Mã loại, Tên loại',
  },
  ActivityCategoryDetail: {
    CategoryCode: 'Mã loại *',
    CategoryName: 'Tên loại *',
    Belong: 'Thuộc loại',
    ReceiptAccount: 'TK thu',
    ReceiptAccountTooltip: 'Tài khoản thu',
    ExpenseAccount: 'TK chi',
    ExpenseAccountTooltip: 'Tài khoản chi',
  },
};
